import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  PublicOrganisation,
  UpdateOrganisationDto,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateOrganisation = async ({
  id,
  organisation,
}: {
  id: string;
  organisation: UpdateOrganisationDto;
}): Promise<PublicOrganisation> => {
  // yes, you need to pass the id in the url before the resource name
  const response = await axiosClient.patch(`${id}/organisations`, organisation);
  return response.data;
};

function useUpdateOrganisation(
  mutationOptions?: UseMutationOptions<
    PublicOrganisation,
    HttpError,
    { id: string; organisation: UpdateOrganisationDto }
  >,
) {
  return useMutation({
    mutationFn: updateOrganisation,
    ...mutationOptions,
  });
}

export { useUpdateOrganisation };
